import algoliasearch from 'algoliasearch';
import React from 'react';
import turfDistance from '@turf/distance';
import AlgoliaSearchBox from '../../../../components/AlgoliaSearchBox';
import { OptionButtons } from './option_buttons';
import { RegionAndCountrySelect } from './region_and_country_select';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import { TrackUploadForm } from '../uploads/track_upload_form';
import { VerifiedRouteContributeItem } from './verified_route_contribute_item';
import { pointItemToLngLat } from '../../../../utils/mapbox/sources/point_items';
import { MapStatsUtil } from '../../../../utils/map_stats_util';

const createReactClass = require('create-react-class');

const METERS_TO_MILES = 0.000621371;

const TrailDetailsBox = createReactClass({
  getInitialState() {
    let areaId;
    if (this.props.trail.area) {
      areaId = this.props.trail.area.id;
    }
    let cityId;
    if (this.props.trail.location) {
      cityId = this.props.trail.location.city_id;
    }

    let activities = {};
    let obstacles = {};
    let features = {};
    if (this.props.trail.attributes.activities.length > 0)
      activities = this.props.trail.attributes.activities.reduce((map, act) => {
        map[act.uid] = act;
        return map;
      }, {});
    if (this.props.trail.attributes.obstacles.length > 0)
      obstacles = this.props.trail.attributes.obstacles.reduce((map, act) => {
        map[act.uid] = act;
        return map;
      }, {});
    if (this.props.trail.attributes.features.length > 0)
      features = this.props.trail.attributes.features.reduce((map, act) => {
        map[act.uid] = act;
        return map;
      }, {});
    this.originalActivities = $.extend({}, activities);
    this.originalFeatures = $.extend({}, features);
    this.originalObstacles = $.extend({}, obstacles);
    if (
      this.props.useMapAsRoute &&
      this.props.useMapAsRoute.tracks &&
      this.props.useMapAsRoute.tracks[0] &&
      this.props.useMapAsRoute.tracks[0].activity
    ) {
      activities[this.props.useMapAsRoute.tracks[0].activity.uid] = this.props.useMapAsRoute.tracks[0].activity;
    }
    return {
      difficultyRating: this.props.trail.defaultActivityStats.difficulty,
      visitorUsage: this.props.trail.defaultActivityStats.visitorUsage,
      location: { latitude: '', longitude: '' },
      allActivities: [],
      allObstacles: [],
      allFeatures: [],
      allAccessibility: [],
      checkedActivities: activities,
      checkedFeatures: features,
      checkedObstacles: obstacles,
      areaId,
      cityId,
      nearbyCities: [],
      nearbyParks: []
    };
  },
  handleError() {},
  handleComplete() {},
  componentDidMount() {
    ServerCommunicationUtil.getApiEndpoint(
      '/api/alltrails/trails/attributes',
      {},
      this.handleAllActivitiesLoad,
      this.handleError,
      this.handleComplete
    );

    let areaText;
    let cityText;
    let cityLocation;

    const trailLngLat = pointItemToLngLat(this.props.trail);
    if (trailLngLat) {
      // Set city-relevant info
      const cityDistanceTo = this.props.currentCity ? turfDistance(trailLngLat, pointItemToLngLat(this.props.currentCity)) * 1000 : 0;
      cityText = `${this.props.trail.location.city} (${this.metersToFormattedUserUnits(cityDistanceTo)})`;
      cityLocation =
        (this.props.trail.location.regionName ? `${this.props.trail.location.regionName}, ` : '') + this.props.trail.location.country_name;
      // Set area-relevant info
      if (this.props.trail.area) {
        const areaDistanceTo = turfDistance(trailLngLat, pointItemToLngLat(this.props.trail.area)) * 1000;
        areaText = `${this.props.trail.area.name} (${this.metersToFormattedUserUnits(areaDistanceTo)})`;
      }
    }

    const latitude = Math.round(parseFloat(trailLngLat[1]) * 10000000) / 10000000;
    const longitude = Math.round(parseFloat(trailLngLat[0]) * 10000000) / 10000000;

    if (!this.listeners) {
      this.listeners = [];
    }
    this.listeners.push(this.props.messagingChannel.subscribe('map.bounds.changed', this.viewBoundsChanged));

    this.algoliaRef = algoliasearch(StringConstantsMixin.constants.ALGOLIA.ACCOUNT, StringConstantsMixin.constants.ALGOLIA.API_KEY);
    this.algoliaIndex = this.algoliaRef.initIndex(StringConstantsMixin.constants.ALGOLIA.INDEX);
    this.setState(
      {
        location: { latitude, longitude },
        areaText,
        cityText,
        cityLocation
      },
      this.algoliaParksAndCityQuery
    );
  },
  componentDidUpdate(prevProps) {
    const routeInfo = this.props.routeInfo;
    if (prevProps.routeInfo && routeInfo && routeInfo.routeStartPt && routeInfo !== prevProps.routeInfo) {
      this.handleTrailHeadMoved(routeInfo.routeStartPt);
    }
  },
  componentWillUnmount() {
    for (let i = 0; i < this.listeners.length; i++) {
      this.listeners[i].unsubscribe();
    }
  },
  viewBoundsChanged({ center }) {
    this.setState({ mapCenter: center });
  },
  algoliaParksAndCityQuery() {
    this.algoliaParksAndCityQueryLatLng(this.state.location.latitude, this.state.location.longitude);
  },
  algoliaParksAndCityQueryLatLng(lat, lng) {
    this.algoliaIndex.search(
      '',
      {
        aroundLatLng: `${lat},${lng}`,
        aroundRadius: 1000000,
        getRankingInfo: 1,
        facets: ['type'],
        facetFilters: ['type:area'],
        hitsPerPage: 1000
      },
      this.handleParkResults
    );
    this.algoliaIndex.search(
      '',
      {
        aroundLatLng: `${lat},${lng}`,
        aroundRadius: 200000,
        getRankingInfo: 1,
        facets: ['type'],
        facetFilters: ['type:place'],
        hitsPerPage: 100
      },
      this.handleCityResults
    );
  },
  // Remove a given set of attributes from a list
  filterAttributes(attrList, removeAttrList) {
    const attrs = attrList.filter(item => {
      // Need css for last 2
      if (removeAttrList.indexOf(item.uid) >= 0) return false;
      return true;
    });
    return attrs;
  },
  handleAllActivitiesLoad(data) {
    const removedActivities = ['default', 'geocaching', 'mountaineering'];
    const removedFeatures = ['dogs', 'dogs-leash', 'dogs-no', 'kids'];
    const accessibleFeatures = ['ada', 'paved', 'partially-paved', 'strollers'];
    const removedObstacles = ['great', 'old-growth', 'icy', 'flooded'];

    const activities = this.filterAttributes(data.activities, removedActivities);
    activities.sort((a, b) => {
      return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    });
    // accesibility tags come down as features, so filter them out separately
    const features = this.filterAttributes(data.features, removedFeatures.concat(accessibleFeatures));
    const accessibles = data.features.filter(item => {
      return accessibleFeatures.indexOf(item.uid) > -1;
    });
    const obstacles = this.filterAttributes(data.obstacles, removedObstacles);

    this.setState({
      allActivities: activities,
      allFeatures: features,
      allObstacles: obstacles,
      allAccessibility: accessibles
    });
  },
  handleTrailHeadMoved(lngLatLike) {
    const latitude = Math.round(parseFloat(lngLatLike[1]) * 10000000) / 10000000;
    const longitude = Math.round(parseFloat(lngLatLike[0]) * 10000000) / 10000000;
    this.setState({
      location: { latitude, longitude }
    });
    this.algoliaParksAndCityQueryLatLng(latitude, longitude);
    if (this.state.cityId == -2) {
      this.updateTrailHeadGeocode();
    }
  },
  updateTrailHeadGeocode() {
    this.setState({ geocodedCityText: 'Loading...' });
    const revGeocodeUrl = '/api/alltrails/locations/reverse_geocode_city';
    const successFunc = function(data, status, xhr) {
      if (data && data.name) {
        this.setState({ geocodedCityText: data.name });
      }
    }.bind(this);
    const errorFunc = function(e) {
      this.setState({ geocodedCityText: 'An error occurred' });
    }.bind(this);
    const completeFunc = function() {};
    if (this.revGeocodeRequest) {
      this.revGeocodeRequest.abort();
      this.revGeocodeRequest = null;
    }
    const params = {
      latitude: this.state.location.latitude,
      longitude: this.state.location.longitude
    };
    this.revGeocodeRequest = ServerCommunicationUtil.postApiEndpoint(revGeocodeUrl, params, successFunc, errorFunc, completeFunc);
  },
  handleCityChange(e) {
    const cityId = parseInt(e.currentTarget.value);
    if (cityId === -2) {
      this.updateTrailHeadGeocode();
    }
    const city = this.state.nearbyCities.filter(city => {
      return city[0] == cityId;
    });
    let cityText = null;
    let cityLocation = null;
    if (city && city[0]) {
      // Do not keep distance-to as will likely be different when this is re-displayed
      cityText = city[0][1].replace(/ \(.*mi\)$/, '');
      cityLocation = city[0][2];
    }
    this.setState({ cityId, cityText, cityLocation });
  },
  getSelectedActivites() {
    const selectedActivites = [];
    Object.keys(this.state.checkedActivities).forEach(
      function(key, idx) {
        selectedActivites.push(this.state.checkedActivities[key].uid);
      }.bind(this)
    );
    return selectedActivites;
  },
  getNameEdit() {
    return { type: 'name', data: { name: this.refs.name.value } };
  },
  getAllTrailEdits() {
    const allEdits = [];
    if (this.refs.name.value != this.props.trail.name) {
      allEdits.push(this.getNameEdit());
    }
    let seasonStart;
    let seasonEnd;
    seasonStart = parseInt(this.refs.seasonStart.value);
    if (isNaN(seasonStart)) {
      seasonStart = -1;
    }
    seasonEnd = parseInt(this.refs.seasonEnd.value);
    if (isNaN(seasonEnd)) {
      seasonEnd = -1;
    }

    if (seasonStart != this.props.trail.defaultActivityStats.seasonStart) {
      allEdits.push({ type: 'season_start', data: { month: seasonStart } });
    }

    if (seasonEnd != this.props.trail.defaultActivityStats.seasonEnd) {
      allEdits.push({ type: 'season_end', data: { month: seasonEnd } });
    }

    if (!this.props.isPendingTrail || (this.props.adminUser && this.props.trail.id)) {
      if (this.refs.length.value != MapStatsUtil.metersToMiles(this.props.trail.trailGeoStats.length)) {
        allEdits.push({ type: 'length', data: { length: parseFloat(this.refs.length.value) } });
      }
    }

    const adminNotes = this.refs.key_points ? this.refs.key_points.value : null;
    if (adminNotes) {
      allEdits.push({ type: 'trail_detail', data: { name: 'key_points', value: adminNotes } });
    }

    const newDr = this.refs.difficultyRating.getSelectedOptionValue();
    if (newDr != this.convertDifficultyRating(this.props.trail.defaultActivityStats.difficulty)) {
      allEdits.push({ type: 'difficulty_rating', data: { difficultyRating: parseInt(newDr) } });
    }
    const newVu = this.refs.visitorUsage.getSelectedOptionValue();
    if (newVu != this.props.trail.defaultActivityStats.visitorUsage) {
      allEdits.push({ type: 'visitor_usage', data: { visitorUsage: parseInt(newVu) } });
    }

    const newRt = this.refs.routeType.getSelectedOptionValue();
    if (newRt && this.props.trail.routeType == null) allEdits.push({ type: 'route_type', data: { routeType: newRt } });
    else if (newRt != null && newRt != this.props.trail.routeType.uid) allEdits.push({ type: 'route_type', data: { routeType: newRt } });

    if (Object.keys(this.state.checkedActivities) != Object.keys(this.originalActivities)) {
      Object.keys(this.state.checkedActivities).forEach((key, idx) => {
        if (Object.keys(this.originalActivities).indexOf(key) < 0) {
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'Y' },
            relation_id: this.state.checkedActivities[key].uid
          });
        }
      });
      Object.keys(this.originalActivities).forEach((key, idx) => {
        if (Object.keys(this.state.checkedActivities).indexOf(key) < 0) {
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'N' },
            relation_id: this.originalActivities[key].uid
          });
        }
      });
    }
    if (Object.keys(this.state.checkedFeatures) != Object.keys(this.originalFeatures)) {
      Object.keys(this.state.checkedFeatures).forEach((key, idx) => {
        if (Object.keys(this.originalFeatures).indexOf(key) < 0)
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'Y' },
            relation_id: this.state.checkedFeatures[key].uid
          });
      });
      Object.keys(this.originalFeatures).forEach((key, idx) => {
        if (Object.keys(this.state.checkedFeatures).indexOf(key) < 0) {
          allEdits.push({
            type: 'attribute',
            data: { allowed: 'N' },
            relation_id: this.originalFeatures[key].uid
          });
        }
      });
    }
    if (Object.keys(this.state.checkedObstacles) != Object.keys(this.originalObstacles)) {
      Object.keys(this.state.checkedObstacles).forEach(
        function(key, idx) {
          if (Object.keys(this.originalObstacles).indexOf(key) < 0)
            allEdits.push({
              type: 'attribute',
              data: { allowed: 'Y' },
              relation_id: this.state.checkedObstacles[key].uid
            });
        }.bind(this)
      );
      Object.keys(this.originalObstacles).forEach(
        function(key, idx) {
          if (Object.keys(this.state.checkedObstacles).indexOf(key) < 0) {
            allEdits.push({
              type: 'attribute',
              data: { allowed: 'N' },
              relation_id: this.originalObstacles[key].uid
            });
          }
        }.bind(this)
      );
    }
    // Handle the features we pulled out from the list
    const originalFeatureKeys = Object.keys(this.originalFeatures);
    const new_value = this.refs.dogs.getSelectedOptionValue();
    if (new_value != this.getDogsValue(this.originalFeatures)) {
      let dogs = 'U';
      let dogs_leash = 'U';
      let dogs_no = 'U';
      switch (new_value) {
        case 'L':
          dogs_leash = 'Y';
          break;
        case 'Y':
          dogs = 'Y';
          break;
        case 'N':
          dogs_no = 'Y';
          break;
        default:
          break;
      }
      allEdits.push({ type: 'attribute', data: { allowed: dogs }, relation_id: 'dogs' });
      allEdits.push({
        type: 'attribute',
        data: { allowed: dogs_leash },
        relation_id: 'dogs-leash'
      });
      allEdits.push({ type: 'attribute', data: { allowed: dogs_no }, relation_id: 'dogs-no' });
    }
    // Kids
    if (originalFeatureKeys.indexOf('kids') >= 0 && this.refs.kids.getSelectedOptionValue() == null)
      allEdits.push({ type: 'attribute', data: { allowed: 'N' }, relation_id: 'kids' });
    else if (originalFeatureKeys.indexOf('kids') < 0 && this.refs.kids.getSelectedOptionValue() == 'Y')
      allEdits.push({ type: 'attribute', data: { allowed: 'Y' }, relation_id: 'kids' });

    // Three cases: park chosen (this.state.areaId > 0), free-form chosen (this.state.areaId == -1), no park (else)
    const areaIdWas = this.props.trail.area ? this.props.trail.area.id : null;
    if (this.state.areaId > 0) {
      if (this.state.areaId != areaIdWas) allEdits.push({ type: 'area', relation_id: this.state.areaId, data: { comment: '' } });
    } else if (this.state.areaId == -1 || this.state.nearbyParks.length == 0) {
      if (this.refs.areaFreeForm) {
        const freeFormArea = this.refs.areaFreeForm.value;
        if (freeFormArea != '')
          allEdits.push({
            type: 'new_area',
            data: {
              name: freeFormArea,
              latitude: this.state.location.latitude,
              longitude: this.state.location.longitude
            }
          });
      }
    } else if (areaIdWas) allEdits.push({ type: 'area', relation_id: null, data: { comment: 'area_id null' } });

    if (!this.props.isPendingTrail || (this.props.adminUser && this.props.trail.id)) {
      // Four cases: City chosen (this.state.cityId > 0); Free-form chosen (this.state.cityId == -1 or no nearby cities found);
      // Admin-only "clear and regeocode" (this.state.cityId == -2); Else--should not occur
      const cityIdWas = this.props.trail.location && this.props.trail.location.city_id ? this.props.trail.location.city_id : null;
      if (this.state.cityId > 0) {
        if (this.state.cityId != cityIdWas) allEdits.push({ type: 'city_id', relation_id: this.state.cityId, data: { comment: '' } });
      } else if (this.state.cityId == -2) {
        allEdits.push({ type: 'city_id', relation_id: null, data: { comment: '' } });
      } else if (this.state.cityId == -1 || this.state.nearbyCities.length == 0) {
        if (this.refs.cityFreeForm) {
          const regionAndCountry = this.refs.regionAndCountry.getSelectedValues();
          const regionId = regionAndCountry.regionId === null ? 0 : regionAndCountry.regionId;
          const freeFormCity = this.refs.cityFreeForm.value;
          if (freeFormCity != '')
            allEdits.push({
              type: 'new_city',
              data: {
                name: freeFormCity,
                latitude: this.state.location.latitude,
                longitude: this.state.location.longitude,
                region_id: regionId,
                country_id: regionAndCountry.countryId
              }
            });
        }
      }
    }

    // Verified Route (if drawn)
    const editData = this.refs.verifiedRouteContribute.getNewEditData();
    if (editData) allEdits.push(editData);

    return allEdits;
  },
  getNameValue() {
    return this.refs.name.value;
  },
  getRouteTypeValue() {
    return this.refs.routeType.getSelectedOptionValue();
  },
  metersToMiles(length, inverse) {
    return Math.round(length * METERS_TO_MILES * 100) / 100;
  },
  metersToFormattedUserUnits(length) {
    if (this.props.displayMetric) {
      return `${(length / 1000.0).toFixed(2)} km`;
    }
    return `${MapStatsUtil.metersToMiles(length)} mi`;
  },
  handleParkResults(err, content) {
    const parks = [];
    let areaInResults = false;
    content.hits.forEach((park, idx) => {
      parks.push([park.ID, `${park.name} (${this.metersToFormattedUserUnits(park._rankingInfo.geoDistance)})`]);
      if (this.state.areaId && park.ID == this.state.areaId) areaInResults = true;
    });
    // If our current park is not in list returned by Algolia, append it now:
    if (this.state.areaId && this.state.areaId != -1 && !areaInResults) parks.push([this.state.areaId, this.state.areaText]);
    this.setState({ nearbyParks: parks });
  },
  createAreaOption(park) {
    return <option value={park[0]}>{park[1]}</option>;
  },
  handleCityResults(err, content) {
    const cities = [];
    let cityInResults = false;
    content.hits.forEach((city, idx) => {
      if (city.objectID.substring(0, 6) != 'cityo-') return;
      cities.push([city.ID, `${city.name} (${this.metersToFormattedUserUnits(city._rankingInfo.geoDistance)})`, city.state_name]);
      if (this.state.cityId && city.ID == this.state.cityId) cityInResults = true;
    });
    // If our current city is not in list returned by Algolia, append it now:
    if (this.state.cityId && this.state.cityId > 0 && !cityInResults) cities.push([this.state.cityId, this.state.cityText, this.state.cityLocation]);
    this.setState({ nearbyCities: cities });
  },
  createCityOption(city) {
    return <option value={city[0]}>{city[1]}</option>;
  },
  convertDifficultyRating(dr) {
    if (!dr) return null;
    if (dr < 3) return 1;
    if (dr < 5) return 3;
    if (dr < 7) return 5;
    if (dr < 9) return 7;
    return null;
  },
  getDogsValue(features) {
    let value = null;
    if (Object.keys(features).indexOf('dogs-leash') >= 0) value = 'L';
    else if (Object.keys(features).indexOf('dogs-no') >= 0) value = 'N';
    else if (Object.keys(features).indexOf('dogs') >= 0) value = 'Y';
    return value;
  },
  handleObjectSelected(obj) {
    let objName;
    let zoom = 12;
    let areaId = null;
    if (obj.objectID.indexOf('city') >= 0) {
      objName = obj.name[1];
    } else if (obj.objectID.indexOf('area') >= 0) {
      objName = obj.name;
      areaId = obj.ID;
    } else {
      objName = obj.name;
    }
    if (obj.objectID.indexOf('state') >= 0) {
      zoom = 8;
    }

    // If we have a geolocation for the object use it
    // Otherwise use the calculated name to geocode the location
    if (obj._geoloc != null) {
      this.props.messagingChannel.publish('edit.change_lat_lng', [obj._geoloc.lat, obj._geoloc.lng, zoom]);
      if (areaId) {
        this.setState({ areaId, areaText: objName });
      } else {
        // clear any selected park if we are being taken to a new Place
        this.setState({ areaId: null, areaText: null });
      }
      this.algoliaParksAndCityQueryLatLng(obj._geoloc.lat, obj._geoloc.lng);
    } else {
      if (!areaId) {
        this.setState({ areaId: null, areaText: null });
      }
      $.ajax({
        url: `https://api.mapbox.com/v4/geocode/mapbox.places/${objName}.json?access_token=pk.eyJ1IjoiYWxsdHJhaWxzIiwiYSI6IkZGaGhGLWsifQ.Fl0FrDM8-xonRV6x2HFqcw`,
        success: data => {
          const [lng, lat] = data.features[0].center;
          this.props.messagingChannel.publish('edit.change_lat_lng', [lat, lng, zoom]);
          this.algoliaParksAndCityQueryLatLng(lat, lng);
        }
      });
    }
  },
  renderNameInput() {
    let name;
    if (this.props.trail && this.props.trail.name) {
      name = this.props.trail.name;
    } else if (this.props.useMapAsRoute && this.props.useMapAsRoute.name) {
      name = this.props.useMapAsRoute.name;
    } else {
      name = '';
    }
    if (this.props.allowNameEditing) {
      return (
        <input
          id="name"
          ref="name"
          className="text"
          data-test-id="nameContribute"
          maxLength={150}
          defaultValue={name}
          onBlur={this.handleTrailNameBlur}
        />
      );
    }
    const editNameLink = `/edit-translations?table=trails&column_name=name&id=${this.props.trail.id}`;
    return (
      <div>
        <input id="name" disabled="disabled" ref="name" className="text" maxLength={150} defaultValue={name} />
        <a className="name-edit-link" href={editNameLink} target="_blank">
          Edit Name
        </a>
      </div>
    );
  },
  handleTrailNameBlur() {
    if (this.refs.name.value.indexOf('Trial') > -1) {
      alert('This trail name contains the word "Trial" instead of the word "Trail". Please ignore this message if this was intentional.');
    }
    return true;
  },
  handleUploadToggle() {
    this.setState({ uploadFormVisible: !this.state.uploadFormVisible });
  },
  handleUploadCancelClick() {
    this.setState({ uploadFormVisible: false });
  },
  handleUploadSuccess(newData) {
    this.setState({ uploadFormVisible: false }, () => {
      this.props.handleMapChange(newData.maps[0]);
    });
  },
  handleAreaSelect(area) {
    const areaDistanceTo = turfDistance(pointItemToLngLat(this.state), pointItemToLngLat(area)) * 1000;
    const areaText = `${area.name} (${this.metersToFormattedUserUnits(areaDistanceTo)})`;
    this.setState({ areaId: area.ID, areaText });
  },
  enableNewParkClick() {
    this.setState({ areaId: -1, areaText: StringConstantsMixin.strings.CONTRIBUTE.NEW_PARK });
  },
  clearSelectedPark() {
    this.setState({ areaId: undefined, areaText: undefined });
  },
  renderAdminNotesSection() {
    if (this.props.adminUser && this.props.trail && this.props.trail.trailDetail) {
      return (
        <div className="edit-field">
          <span className="field-name ellipse">Admin Notes</span>
          <textarea className="text admin" ref="key_points" data-test-id="AdminNotes" defaultValue={this.props.trail.trailDetail.key_points} />
        </div>
      );
    }
    return null;
  },
  renderMonthOptions() {
    const options = StringConstantsMixin.strings.MONTHS.map((item, index) => {
      return (
        <option value={index + 1} key={`months-${index}`}>
          {item}
        </option>
      );
    });
    return options;
  },
  renderParkEditField() {
    // areaOptions
    const areaOptions = this.state.nearbyParks.map(this.createAreaOption);
    if (this.state.nearbyParks.length > 0) areaOptions.unshift(<option value="">{StringConstantsMixin.strings.CONTRIBUTE.SELECT_A_PARK}:</option>);
    areaOptions.push(<option value="-1">{StringConstantsMixin.strings.CONTRIBUTE.ADD_NEW_PARK}</option>);
    // null input
    let nlInput;
    if (this.state.areaId == -1 || this.state.nearbyParks.length == 0) {
      nlInput = (
        <input ref="areaFreeForm" className="second-line-text text" placeholder={StringConstantsMixin.strings.CONTRIBUTE.ENTER_NEW_PARK_NAME} />
      );
    }
    // clear button
    let clearBtn;
    if (this.state.areaId) {
      clearBtn = (
        <span>
          {' '}
          - <a onClick={this.clearSelectedPark}>{StringConstantsMixin.strings.CLEAR}</a>
        </span>
      );
    }
    // lat/lng
    let defaultLatLng = [this.state.location.latitude, this.state.location.longitude];
    let weightResults = false; // if a trail head has been selected, order parks by proximity (not popularity)
    // use center of map if the defaultLatLng is set to center coordinates of U.S. (aka hasn't been set to any value yet)
    if (defaultLatLng && defaultLatLng[0] == 39.8282102 && defaultLatLng[1] == -98.581832 && this.state.mapCenter) {
      defaultLatLng = this.state.mapCenter;
      weightResults = true;
    }
    let label;
    if (this.state.areaText || clearBtn) {
      label = (
        <label>
          {this.state.areaText}
          {clearBtn}
        </label>
      );
    }
    // park algolia search box selection
    const parkSelection = (
      <div className="contains-search-box">
        {label}
        <AlgoliaSearchBox
          mobileBrowser={false}
          languageRegionCode={this.props.languageRegionCode}
          typeSubset={['area']}
          placeholderText={StringConstantsMixin.strings.CONTRIBUTE.SELECT_A_PARK}
          handleAreaSelect={this.handleAreaSelect}
          defaultLatLng={defaultLatLng}
          displayDistanceToLatLng
          displayMetric={this.props.displayMetric}
          weightResults={weightResults}
        />
        {nlInput}
      </div>
    );
    // parkEditLink
    const newBtn = <a onClick={this.enableNewParkClick}>{StringConstantsMixin.strings.CONTRIBUTE.NEW}</a>;
    let editBtn;
    let parkEditLink = <span>({newBtn})</span>;
    if (this.state.areaId && this.props.adminUser) {
      const parkLink = `/merge-locations?area_id=${this.state.areaId}`;
      editBtn = (
        <a href={parkLink} target="_blank">
          {StringConstantsMixin.strings.EDIT}
        </a>
      );
      parkEditLink = (
        <div>
          ({newBtn} / {editBtn})
        </div>
      );
    }
    // edit-field
    return (
      <div className="edit-field">
        <span className="field-name">
          {StringConstantsMixin.strings.FILTERS.PARK} {parkEditLink}
        </span>
        {parkSelection}
      </div>
    );
  },

  // Code extracted from AttributeMixin
  handleActivitySelection(activity) {
    const acts = this.state.checkedActivities;
    if (Object.keys(acts).indexOf(activity.uid) >= 0) {
      acts[activity.uid] = null;
      delete acts[activity.uid];
    } else {
      acts[activity.uid] = activity;
    }
    this.setState({ checkedActivities: acts });
  },
  handleFeatureSelection(feature) {
    const feats = this.state.checkedFeatures;
    if (Object.keys(feats).indexOf(feature.uid) >= 0) {
      feats[feature.uid] = null;
      delete feats[feature.uid];
    } else {
      feats[feature.uid] = feature;
    }
    this.setState({ checkedFeatures: feats });
  },
  handleObstacleSelection(obstacle) {
    const obs = this.state.checkedObstacles;
    if (Object.keys(obs).indexOf(obstacle.uid) >= 0) {
      obs[obstacle.uid] = null;
      delete obs[obstacle.uid];
    } else {
      obs[obstacle.uid] = obstacle;
    }
    this.setState({ checkedObstacles: obs });
  },
  createAttributeInput(activity, checkedAttributes, handleAttributeSelection, stringConstantHash) {
    let classes = `${StringConstantsMixin.constants.XLATE.NONE} btn-slim brown activity-select`;
    let text = StringConstantsMixin.stringsLookup(stringConstantHash, activity.name).toLowerCase();
    if (Object.keys(checkedAttributes).indexOf(activity.uid) >= 0) {
      classes += ' selected';
      text += ' ×';
    }
    return (
      <a className={classes} data-test-id={text} onClick={handleAttributeSelection.bind(null, activity)}>
        {text}
      </a>
    );
  },
  createActivityInput(activity) {
    return this.createAttributeInput(
      activity,
      this.state.checkedActivities,
      this.handleActivitySelection,
      StringConstantsMixin.strings.FILTERS.ACTIVITIES
    );
  },
  createFeatureInput(feature) {
    return this.createAttributeInput(
      feature,
      this.state.checkedFeatures,
      this.handleFeatureSelection,
      StringConstantsMixin.strings.FILTERS.FEATURE_TYPES
    );
  },
  createAccessInput(feature) {
    return this.createAttributeInput(feature, this.state.checkedFeatures, this.handleFeatureSelection, StringConstantsMixin.strings.FILTERS.ACCESS);
  },
  createObstacleInput(obstacle) {
    return this.createAttributeInput(
      obstacle,
      this.state.checkedObstacles,
      this.handleObstacleSelection,
      StringConstantsMixin.strings.FILTERS.OBSTACLES
    );
  },

  render() {
    const activitySelection = this.state.allActivities.map(this.createActivityInput);
    const featureSelection = this.state.allFeatures.map(this.createFeatureInput);
    const accessibilitySelection = this.state.allAccessibility.map(this.createAccessInput);
    const obstacleSelection = this.state.allObstacles.map(this.createObstacleInput);

    let adminCityEditLink = null;

    if (this.state.cityId && this.props.adminUser) {
      const cityLink = `/merge-locations?city_id=${this.state.cityId}`;
      adminCityEditLink = (
        <span>
          (
          <a href={cityLink} target="_blank">
            {StringConstantsMixin.strings.EDIT}
          </a>
          )
        </span>
      );
    }

    let cityAndRegionDiv = null;
    let lengthDiv = null;
    let routeInstructions = null;

    if (!this.props.isPendingTrail || (this.props.adminUser && this.props.trail.id)) {
      const cityOptions = this.state.nearbyCities.map(this.createCityOption);
      if (this.state.nearbyCities.length > 0) cityOptions.unshift(<option value="">Select a city:</option>);
      cityOptions.push(<option value="-1">Add new city</option>);
      if (this.props.adminUser) cityOptions.push(<option value="-2">Clear and regeocode city</option>);
      let regionCountryDiv;
      if (this.state.cityId == -2) {
        regionCountryDiv = <p className="rev-geocode-txt">Trailhead's location: {this.state.geocodedCityText}</p>;
      } else if (this.state.cityId == -1 || this.state.nearbyCities.length == 0) {
        regionCountryDiv = (
          <div>
            <input ref="cityFreeForm" className="second-line-text text" />
            <div>
              <span className="field-name">{StringConstantsMixin.strings.LOCATIONS.REGION}</span>
              <RegionAndCountrySelect
                ref="regionAndCountry"
                initialRegion={this.props.currentCity ? this.props.currentCity.state : null}
                initialCountry={this.props.currentCity ? this.props.currentCity.country : null}
              />
            </div>
          </div>
        );
      } else {
        let adminStateEditLink = null;
        if (this.state.cityId && this.props.adminUser) {
          const link = `/merge-locations?state_of_city_id=${this.state.cityId}`;
          adminStateEditLink = (
            <span>
              (
              <a href={link} target="_blank">
                {StringConstantsMixin.strings.EDIT}
              </a>
              )
            </span>
          );
        }
        regionCountryDiv = (
          <div>
            <span className="field-name">
              {StringConstantsMixin.strings.LOCATIONS.REGION} {adminStateEditLink}
            </span>
            <input className="text" readOnly value={this.state.cityLocation} />
          </div>
        );
      }

      cityAndRegionDiv = (
        <div className="edit-field">
          <span className="field-name">
            {StringConstantsMixin.strings.LOCATIONS.CITY} {adminCityEditLink}
          </span>
          <div>
            <select id="city" ref="city" onChange={this.handleCityChange} value={this.state.cityId ? this.state.cityId : ''}>
              {cityOptions}
            </select>
            {regionCountryDiv}
          </div>
        </div>
      );

      if (this.props.displayMetric) {
        lengthDiv = (
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.FILTERS.LENGTH}</span>
            <input id="length" ref="length" className="text half" defaultValue={(this.props.trail.trailGeoStats.length / 1000.0).toFixed(2)} />
            <span className="faded">
              {StringConstantsMixin.strings.ELEV_CHART.DISTANCE} ({StringConstantsMixin.strings.CONTRIBUTE.IN_KILOMETERS})
            </span>
          </div>
        );
      } else {
        lengthDiv = (
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.ELEV_CHART.DISTANCE}</span>
            <input id="length" ref="length" className="text half" defaultValue={MapStatsUtil.metersToMiles(this.props.trail.trailGeoStats.length)} />
            <span className="faded">
              {StringConstantsMixin.strings.ELEV_CHART.DISTANCE} ({StringConstantsMixin.strings.CONTRIBUTE.IN_MILES})
            </span>
          </div>
        );
      }
    } else {
      routeInstructions = <div id="verified-route-instructions">{StringConstantsMixin.strings.CONTRIBUTE.ROUTE_INSTRUCTIONS_W_GPX}</div>;
    }

    let step_titles;
    let searchDividerDiv = null;
    let searchDiv = null;

    const uploadDiv = (
      <div>
        <div className="edit-field-or-divider">
          <span>{StringConstantsMixin.strings.OR}</span>
        </div>
        <div className="edit-field">
          <span className="field-name allow-lengthen">{StringConstantsMixin.strings.CONTRIBUTE.UPLOAD_ROUTE}</span>
          <div className="option-button-group">
            <button className="option-button" onClick={this.handleUploadToggle} data-test-id="uploadButtonContribute">
              {StringConstantsMixin.strings.CONTRIBUTE.UPLOAD_ROUTE}
            </button>
          </div>
          <TrackUploadForm
            formVisible={this.state.uploadFormVisible}
            onCancelClick={this.handleUploadCancelClick}
            uploadClick={this.handleUploadToggle}
            uploadSuccess={this.handleUploadSuccess}
            systemOwned
            offerSmoothOption
          />
        </div>
      </div>
    );

    if (this.props.trail.id) {
      step_titles = [
        null,
        `${StringConstantsMixin.strings.CONTRIBUTE.STEPS[0]} - ${StringConstantsMixin.strings.CONTRIBUTE.BETTER_ROUTE}`,
        `${StringConstantsMixin.strings.CONTRIBUTE.STEPS[1]} - ${StringConstantsMixin.strings.CONTRIBUTE.EDIT_TRAIL_INFO}`
      ];
    } else {
      step_titles = [
        `${StringConstantsMixin.strings.CONTRIBUTE.STEPS[0]} - ${StringConstantsMixin.strings.CONTRIBUTE.FIND_START_LOC}`,
        `${StringConstantsMixin.strings.CONTRIBUTE.STEPS[1]} - ${StringConstantsMixin.strings.CONTRIBUTE.DRAW_UPLOAD_RT}`,
        `${StringConstantsMixin.strings.CONTRIBUTE.STEPS[2]} - ${StringConstantsMixin.strings.CONTRIBUTE.EDIT_TRAIL_INFO}`
      ];
      searchDividerDiv = (
        <div className="edit-field-divider">
          <span>{step_titles[0]}</span>
        </div>
      );
      searchDiv = (
        <div>
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.CITY_OR_PARK}</span>
            <div className="search-holder">
              <AlgoliaSearchBox
                handleTrailSelect={null}
                handleAreaSelect={this.handleObjectSelected}
                handleLocationSelect={this.handleObjectSelected}
                handleQueryStringSubmit={null}
                typeSubset={['area', 'place']}
                placeholderText={StringConstantsMixin.strings.SEARCH.ENTER_CITY_PARK_OR_LAT_LNG}
                enterSelectsFirstMatch
                numResults={10}
                languageRegionCode={this.props.languageRegionCode}
                messagingChannel={this.props.messagingChannel}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div id="trail-details-box" className="trail-details">
        <div>
          {searchDividerDiv}
          {searchDiv}
          <div className="edit-field-divider">
            <span>{step_titles[1]}</span>
          </div>
          <div className="edit-field">
            {routeInstructions}
            <span className="field-name allow-lengthen">{StringConstantsMixin.strings.CONTRIBUTE.DRAW_ROUTE}</span>
            <VerifiedRouteContributeItem
              adminUser={this.props.adminUser}
              displayMetric={this.props.displayMetric}
              forTrailDetails
              mapModel={this.props.useMapAsRoute}
              messagingChannel={this.props.messagingChannel}
              rapidRoute={this.props.rapidRoute}
              ref="verifiedRouteContribute"
              routeInfo={this.props.routeInfo}
              trail={this.props.trail}
            />
          </div>
          {uploadDiv}
          <div className="edit-field-divider">
            <span>{step_titles[2]}</span>
          </div>
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.FILTERS.SORT_TYPES.NAME}</span>
            {this.renderNameInput()}
          </div>
          {this.renderParkEditField()}
          {cityAndRegionDiv}
          {lengthDiv}
          <div className="edit-field">
            <span className="field-name ellipse">{StringConstantsMixin.strings.FILTERS.ROUTE_TYPE}</span>
            <OptionButtons
              ref="routeType"
              optionDefs={[
                { value: 'L', name: StringConstantsMixin.strings.FILTERS.ROUTE_TYPES.LOOP },
                { value: 'O', name: StringConstantsMixin.strings.FILTERS.ROUTE_TYPES.OUT_AND_BACK },
                { value: 'P', name: StringConstantsMixin.strings.FILTERS.ROUTE_TYPES.POINT_TO_POINT }
              ]}
              initialValue={this.props.trail.routeType ? this.props.trail.routeType.uid : null}
            />
          </div>
          <div className="edit-field">
            <span className="field-name ellipse">{StringConstantsMixin.strings.FILTERS.DIFFICULTY}</span>
            <OptionButtons
              ref="difficultyRating"
              optionDefs={[
                { value: 1, name: StringConstantsMixin.strings.DIFFICULTY.NORMAL.EASY },
                { value: 3, name: StringConstantsMixin.strings.DIFFICULTY.NORMAL.MODERATE },
                { value: 5, name: StringConstantsMixin.strings.DIFFICULTY.NORMAL.DIFFICULT },
                { value: 7, name: StringConstantsMixin.strings.DIFFICULTY.NORMAL.STRENUOUS }
              ]}
              initialValue={this.convertDifficultyRating(this.props.trail.defaultActivityStats.difficulty)}
            />
          </div>
          <div className="edit-field">
            <span className="field-name ellipse">{StringConstantsMixin.strings.CONTRIBUTE.USAGE}</span>
            <OptionButtons
              ref="visitorUsage"
              optionDefs={[
                { value: 1, name: StringConstantsMixin.strings.FILTERS.USAGES.LIGHT },
                { value: 2, name: StringConstantsMixin.strings.FILTERS.USAGES.MODERATE },
                { value: 3, name: StringConstantsMixin.strings.FILTERS.USAGES.HEAVY },
                { value: 4, name: StringConstantsMixin.strings.FILTERS.USAGES.EXTRA_HEAVY }
              ]}
              initialValue={this.props.trail.defaultActivityStats.visitorUsage}
            />
          </div>
          {this.renderAdminNotesSection()}
          <div className="edit-field">
            <span className="field-name ellipse">{StringConstantsMixin.strings.CONTRIBUTE.SEASON}</span>
            <select
              data-test-id="season-start"
              id="season-start"
              className="half"
              ref="seasonStart"
              defaultValue={this.props.trail.defaultActivityStats.seasonStart}
            >
              <option value="">-- {StringConstantsMixin.strings.START} --</option>
              {this.renderMonthOptions()}
            </select>
            <select
              data-test-id="season-end"
              id="season-end"
              className="half"
              ref="seasonEnd"
              defaultValue={this.props.trail.defaultActivityStats.seasonEnd}
            >
              <option value="">-- {StringConstantsMixin.strings.END} --</option>
              {this.renderMonthOptions()}
            </select>
          </div>
          <div className="activities edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.ACTIVITIES}</span>
            <div className="activity-list">{activitySelection}</div>
          </div>
          <div className="features edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.FEATURES}</span>
            <div className="feature-list">{featureSelection}</div>
          </div>
          <div className="obstacles edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.OBSTACLES}</span>
            <div className="obstacle-list">{obstacleSelection}</div>
          </div>
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.DOGS}</span>
            <OptionButtons
              ref="dogs"
              optionDefs={[
                { value: 'Y', name: StringConstantsMixin.strings.FILTERS.ACCESS.DOGS.toLowerCase() },
                { value: 'L', name: StringConstantsMixin.strings.FILTERS.ACCESS.DOGS_ON_LEASH.toLowerCase() },
                { value: 'N', name: StringConstantsMixin.strings.FILTERS.ACCESS.NO_DOGS.toLowerCase() }
              ]}
              initialValue={this.getDogsValue(this.state.checkedFeatures)}
            />
          </div>
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.ACCESSIBLE}</span>
            <div className="feature-list">{accessibilitySelection}</div>
          </div>
          <div className="edit-field">
            <span className="field-name">{StringConstantsMixin.strings.CONTRIBUTE.KIDS}</span>
            <OptionButtons
              ref="kids"
              optionDefs={[{ value: 'Y', name: StringConstantsMixin.strings.FILTERS.ACCESS.KIDS.toLowerCase() }]}
              initialValue={Object.keys(this.state.checkedFeatures).indexOf('kids') >= 0 ? 'Y' : null}
            />
          </div>
        </div>
      </div>
    );
  }
});

export { TrailDetailsBox };
